import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import Catalog_vue_vue_type_script_setup_true_lang_default from "./Catalog.vue_vue_type_script_setup_true_lang.js";
/* empty css                                            */
/* empty css                                                            */
//#region src/views/Catalog/Catalog.vue
var Catalog_default = /*#__PURE__*/ _plugin_vue_export_helper_default(Catalog_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-18b2aea2"]]);
//#endregion
export { Catalog_default as default };

//# sourceMappingURL=Catalog.vue.js.map